import "./AdminPage.scss";
import Header from "../../components/Header/Header";
import { useNavigate } from "react-router-dom";
import { useCurrentUser } from "../../hooks/useCurrentUser";
import { isAdminRole } from "../../utils/roles";

export const AdminPage = () => {
  const navigate = useNavigate();
  const { user } = useCurrentUser();

  return (
    <>
      <Header />
      <main className="admin-page">
        {isAdminRole(user?.role) ? (
          <section className="admin-page__grid">
            <button className="admin-page__card" type="button" onClick={() => navigate("/app/admin/users")}>
              <span className="admin-page__cardTag">Управление</span>
              <strong className="admin-page__cardTitle">Управление пользователями</strong>
              <span className="admin-page__cardText">
                Открыть таблицу пользователей, фильтровать по username и fullname, просматривать все поля ответа.
              </span>
            </button>
            <button className="admin-page__card" type="button" onClick={() => navigate("/app/admin/subscriptions")}>
              <span className="admin-page__cardTag">Подписки</span>
              <strong className="admin-page__cardTitle">Управление подписками</strong>
              <span className="admin-page__cardText">
                Просматривать типы подписок, создавать новые и изменять существующие значения прямо из админки.
              </span>
            </button>
            <button className="admin-page__card" type="button" onClick={() => navigate("/app/admin/directions")}>
              <span className="admin-page__cardTag">Вопросы</span>
              <strong className="admin-page__cardTitle">Управление направлениями</strong>
              <span className="admin-page__cardText">
                Создание, редактирование и удаление направлений вопросов.
              </span>
            </button>
            <button className="admin-page__card" type="button" onClick={() => navigate("/app/admin/tags")}>
              <span className="admin-page__cardTag">Вопросы</span>
              <strong className="admin-page__cardTitle">Управление тегами</strong>
              <span className="admin-page__cardText">
                Создание, редактирование и удаление тегов вопросов с привязкой к направлению.
              </span>
            </button>
            <button className="admin-page__card" type="button" onClick={() => navigate("/app/admin/analytics")}>
              <span className="admin-page__cardTag">Аналитика</span>
              <strong className="admin-page__cardTitle">Опросник регистрации</strong>
              <span className="admin-page__cardText">
                Статистика ответов на вопрос «Откуда вы узнали о сервисе».
              </span>
            </button>
          </section>
        ) : (
          <section className="admin-page__grid">
            <p className="admin-page__empty">Доступ к этому разделу есть только у администратора.</p>
          </section>
        )}
      </main>
    </>
  );
};
